import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Add Link for navigation
import axios from 'axios';
import QuestionList from './QuestionList';
import QuestionForm from './QuestionForm';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdminDashboard.css';

// Remove console.logs in production
  if (process.env.NODE_ENV !== "development") {
    console.log = () => {};
  }
  
const AdminDashboard = () => {
  const [assessmentFilter, setAssessmentFilter] = useState('Career Assessments');
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const fetchQuestions = async (filter) => {
    setLoading(true);
    try {
      const response = await axios.get('/api/questions', {
          params: { status: filter, _t: Date.now() }, // Cache-busting
      });
      setQuestions(response.data);
      console.log('Fetched questions:', response.data);
    } catch (error) {
      console.error('Error fetching questions:', error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions(assessmentFilter);
    document.body.classList.add('specific-page');
    return () => document.body.classList.remove('specific-page');
  }, [assessmentFilter]);

  const handleFilterChange = (event) => {
    setAssessmentFilter(event.target.value);
  };

  const filterOptions = [
    { value: 'Career Assessments', label: 'Career Assessments' },
    { value: 'Subject Assessments', label: 'Subject Assessments' },
    { value: 'Learning Assessments', label: 'Learning Assessments' },
     { value: 'AI Assessments', label: 'AI Assessments' },
  ];

 const handleQuestionSubmit = async (newQuestion, action) => {
  try {
    if (action === 'add') {
      await axios.post('/api/questions', newQuestion);
      await fetchQuestions(assessmentFilter); // Refresh questions
      setSelectedQuestion(null);
      console.log('Question added');
    } else if (action === 'update') {
      console.log('Updating question with data:', newQuestion);
      const response = await axios.put(
        `/api/questions/${newQuestion.question_id}?_t=${Date.now()}`,
        newQuestion
      );
      console.log('Update response:', response.data);
      // Update questions state to replace the old question
      setQuestions((prev) =>
        prev.map((q) =>
          q.question_id === newQuestion.question_id ? response.data.updatedQuestion : q
        )
      );
      setSelectedQuestion(response.data.updatedQuestion); // Keep form populated
      console.log('Question updated:', response.data.updatedQuestion);
    } else if (action === 'delete') {
      await axios.delete(`/api/questions/${newQuestion.question_id}`);
      setQuestions((prev) => prev.filter((q) => q.question_id !== newQuestion.question_id));
      setSelectedQuestion(null);
      console.log('Question deleted:', newQuestion.question_id);
    }
  } catch (error) {
    console.error(`Error during ${action} question:`, error.response?.data || error.message);
  }
};

  const handleEditQuestion = (question) => {
    console.log('✏️ Edit received:', question);
    setSelectedQuestion({ ...question });
  };

  const handleCopyQuestion = (question) => {
    console.log('📋 Received copied question in AdminDashboard:', question);
    setSelectedQuestion({ ...question, question_id: null }); // Ensure question_id is null
  };

  return (
    <div className="specific-page admin-dashboard-wrapper mt-4">
      <div className="card shadow p-4">
        <header className="admin-dashboard-header text-center mb-4">
          <div className="admin-dashboard-logo"></div>
          <h1 className="text-center mb-4">Admin Dashboard</h1>
        </header>

 {/* Navigation Links */}
        <nav className="mb-4">
          <ul className="nav nav-pills">
            <li className="nav-item"><Link className="nav-link active" to="/admin28976730">Manage Questions</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/facet-management28976730">Manage Facets</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/whitelist-manager28976730">Whitelist Manager</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/jobpost-management28976730">Job Post Manager</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/supercurricularactivity-management28976730">SuperCurricular Manager</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/star-experience-manager28976730">STAR Experiences</Link></li>  
            <li className="nav-item"><Link className="nav-link" to="/top-interview-questions-manager28976730">Interview Questions</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/personal-statement-guidance-manager28976730">Personal Statement</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/rss-feed-manager28976730">RSS Feeds</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/ai-skill-development-manager28976730">AI Skill Development</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/knowledge-cms-manager28976730">Knowledge CMS</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/investor-deck-manager28976730">Investor Deck</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/vc-manager28976730">VC Manager</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/free-courses-manager28976730">Free Courses</Link></li>  
            <li className="nav-item"><Link className="nav-link" to="/startup-tasks-cms28976730">Startup Tasks</Link></li>         
            <li className="nav-item"><Link className="nav-link" to="/team-challenge-manager28976730">Team Challenges</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/coach-the-coach-manager28976730">Coach the Coach</Link></li>    
            <li className="nav-item"><Link className="nav-link" to="/leader-questions-manager28976730">Leader Questions</Link></li>           
                        <li className="nav-item"><Link className="nav-link" to="/profile-group-management28976730">Profile Groups</Link></li>
          </ul>
        </nav>
        
        <div className="row mb-4">
          <div className="col-md-4">
            <select
              className="form-select"
              value={assessmentFilter}
              onChange={handleFilterChange}
            >
              {filterOptions.map((option) => (
                <option className="form-select" key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <QuestionForm
          question={selectedQuestion}
          onSubmit={handleQuestionSubmit}
          filter={assessmentFilter}
        />

        {loading ? (
          <div>Loading questions...</div>
        ) : (
          <QuestionList
            filter={assessmentFilter}
            questions={questions}
            onSubmit={handleQuestionSubmit}
            onEdit={handleEditQuestion}
            onCopy={handleCopyQuestion}
          />
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;